/* B3 Intro galleria — comparsa in sequenza all'ingresso nel viewport.

   Due principi, in quest'ordine:
   1. il contenuto è visibile per default nel CSS. Lo stato nascosto viene
      acceso da qui scrivendo data-b3-anim sul wrapper. Se questo file non
      viene eseguito, o esce prima, la sezione resta leggibile;
   2. nel theme editor si rivela subito, senza aspettare lo scroll. */
(function () {
  var SICUREZZA = 2500;

  function spezzaInParole(titolo) {
    /* Si toccano solo i nodi di testo, quindi <em> e gli altri tag interni
       sopravvivono: le parole dentro il corsivo diventano span dentro
       l'<em>, non al suo posto. */
    var camminatore = document.createTreeWalker(titolo, NodeFilter.SHOW_TEXT, null);
    var nodi = [];
    while (camminatore.nextNode()) nodi.push(camminatore.currentNode);

    var parole = [];
    nodi.forEach(function (nodo) {
      if (!nodo.nodeValue || !nodo.nodeValue.trim()) return;
      var pezzi = nodo.nodeValue.split(/(\s+)/);
      var frammento = document.createDocumentFragment();
      pezzi.forEach(function (pezzo) {
        if (pezzo === '') return;
        if (/^\s+$/.test(pezzo)) {
          frammento.appendChild(document.createTextNode(pezzo));
          return;
        }
        var span = document.createElement('span');
        span.className = 'b3-intro__parola';
        span.textContent = pezzo;
        frammento.appendChild(span);
        parole.push(span);
      });
      nodo.parentNode.replaceChild(frammento, nodo);
    });
    return parole;
  }

  function initIntro(root) {
    if (root.dataset.introInit === 'true') return;
    root.dataset.introInit = 'true';

    if (root.dataset.anima !== 'si') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ritardo = parseInt(root.dataset.ritardo, 10);
    if (isNaN(ritardo)) ritardo = 150;
    var ritardoParole = parseInt(root.dataset.ritardoParole, 10);
    if (isNaN(ritardoParole)) ritardoParole = 80;

    var titolo = root.querySelector('[data-b3-titolo]');
    var parole = titolo ? spezzaInParole(titolo) : [];

    /* Sequenza: occhiello, poi le parole del titolo una a una, poi il testo
       e la riga finale dopo l'ultima parola. Le immagini corrono in
       parallelo alla colonna di testo, nell'ordine 1-2-3-4. */
    var passo = 0;

    var occhiello = root.querySelector('[data-b3-anima="occhiello"]');
    if (occhiello) {
      occhiello.style.setProperty('--b3-intro-ritardo', passo * ritardo);
      passo += 1;
    }

    var dopoTitolo = passo * ritardo;
    parole.forEach(function (parola, i) {
      parola.style.setProperty('--b3-intro-ritardo', dopoTitolo + i * ritardoParole);
    });
    if (parole.length) dopoTitolo += parole.length * ritardoParole;

    ['corpo', 'riga'].forEach(function (nome) {
      var el = root.querySelector('[data-b3-anima="' + nome + '"]');
      if (!el) return;
      dopoTitolo += ritardo;
      el.style.setProperty('--b3-intro-ritardo', dopoTitolo);
    });

    var celle = root.querySelectorAll('[data-b3-anima="immagine"]');
    for (var i = 0; i < celle.length; i++) {
      celle[i].style.setProperty('--b3-intro-ritardo', i * ritardo);
    }

    /* Da qui il CSS nasconde: si accende solo ora, a un passo dal rivelare. */
    root.dataset.b3Anim = 'pronto';

    var fatto = false;
    function rivela() {
      if (fatto) return;
      fatto = true;
      root.dataset.b3Anim = 'dentro';
    }

    /* Nel theme editor la sezione viene ricostruita a ogni modifica e non si
       può chiedere all'utente di scorrere: si rivela al frame dopo. */
    var inEditor = window.Shopify && window.Shopify.designMode;

    if (inEditor || typeof IntersectionObserver === 'undefined') {
      requestAnimationFrame(rivela);
      return;
    }

    var osservatore = new IntersectionObserver(
      function (voci) {
        for (var j = 0; j < voci.length; j++) {
          if (voci[j].isIntersecting) {
            osservatore.disconnect();
            rivela();
            return;
          }
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
    );
    osservatore.observe(root);

    /* Se per qualsiasi motivo l'osservatore non scattasse, il contenuto non
       resta nascosto per sempre. */
    setTimeout(function () {
      if (!fatto) {
        osservatore.disconnect();
        rivela();
      }
    }, SICUREZZA);
  }

  function init() {
    document.querySelectorAll('[data-b3-intro]').forEach(initIntro);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-b3-intro]') : null;
    if (root) {
      root.dataset.introInit = '';
      initIntro(root);
    }
  });
})();
